var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSaveToCloudIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.25 8.25a3.75 3.75 0 0 1 7.408-.832.75.75 0 0 0 .708.584 3.75 3.75 0 0 1-.116 7.498H13a.75.75 0 0 0 0 1.5h.25a5.25 5.25 0 0 0 .718-10.45A5.252 5.252 0 0 0 3.761 8.595 4.5 4.5 0 0 0 6 17h1a.75.75 0 0 0 0-1.5H6a3 3 0 0 1-1.146-5.773.75.75 0 0 0 .453-.823 3.778 3.778 0 0 1-.057-.653Zm4 9.003a.75.75 0 0 0 1.5 0V10.56l1.97 1.97a.75.75 0 0 0 1.06-1.06l-3.25-3.25a.75.75 0 0 0-1.06 0l-3.25 3.25a.75.75 0 1 0 1.06 1.06l1.97-1.97v6.692Z",
  clipRule: "evenodd"
})));
export { SvgSaveToCloudIcon as ReactComponent };